import { useState, useEffect } from 'react';  
  
/**  
 * 自定义Hook，用于追踪窗口的滚动高度  
 * 返回当前窗口的滚动Y轴位置  
 */  
function useWindowScrollHeight() {  
  const [scrollY, setScrollY] = useState(window.scrollY);  
  
  useEffect(() => {  
    const handleScroll = () => {  
      setScrollY(window.scrollY);  
    };  
  
    window.addEventListener('scroll', handleScroll);  
  
    // 清理函数，组件卸载时移除事件监听器  
    return () => {  
      window.removeEventListener('scroll', handleScroll);  
    };  
  }, []); // 空依赖数组意味着这个effect只在组件挂载和卸载时运行  
  
  return scrollY;  
}  
  
export default useWindowScrollHeight;